import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import css from './SectionBanner.module.css';

const SectionBanner = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  return (
    <div id={sectionId} className={classNames(rootClassName || css.root, className)}>
      <div className={css.patternOverlay} />
      {hasHeaderFields ? (
        <div className={css.bannerContent}>
          <div className={css.textContent}>
            <h3>{title?.content}</h3>
            <p>{description?.content}</p>
          </div>
          <Field 
            data={callToAction} 
            className={css.ctaButton} 
            options={fieldOptions} 
          />
        </div>
      ) : null}
    </div>
  );
};

export default SectionBanner;
